import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'registration' })
export class RegistrationPipe implements PipeTransform {
    transform(value: string | number): string {
        let valorFormatado = value + '';

        return valorFormatado.padStart(6, '0');
    }
}
